module.exports = __webpack_public_path__ + "static/media/admin.3b29b0ba.png";